<template>
  <nav aria-label="Breadcrumb">
    <ol class="flex items-center text-sm text-gray-mobly54 text-nowrap flex-nowrap w-full overflow-hidden">
      <li class="flex items-center justify-start flex-shrink min-w-0">
        <a :href="env.VUE_APP_URL + env.VUE_APP_MENU_PANEL" class="hover:text-purple-mobly2A8 truncate "> Minha conta </a>
      </li>
      <li
        v-for="(item, index) in crumbs"
        :key="index"
        class="flex items-center justify-start"
      >
        <ChevronRightIcon class="w-4 h-4 " />
        <router-link
          :to="item.link"
          class="hover:text-purple-mobly2A8"
          :class="index + 1 === crumbs.length ? 'text-purple-mobly2A8' : ''"
        > {{ item.title }} </router-link>
      </li>
    </ol>
  </nav>
</template>

<script>
import { ChevronRightIcon } from "@vue-hero-icons/solid"

export default {
  name: 'Breadcrumb',
  components: {
    ChevronRightIcon
  },
  computed: {
    env: function () {
      return process.env
    }
  },
  mounted() {
    this.crumbs = this.$route.meta.breadcrumbs(this.$route)
  },
  watch: {
    '$route'() {
      this.crumbs = this.$route.meta.breadcrumbs(this.$route)
    }
  },
  data() {
    return {
      crumbs: []
    }
  }
}
</script>
